var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-window",on:{"drop":_vm.handleDrop,"dragover":_vm.throttledDragOver}})
}
var staticRenderFns = []

export { render, staticRenderFns }